var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"mStyle":'width: 620px; padding: 0px;',"noHeader":true,"noFooter":true}},[_c('ResourceInformation',{attrs:{"uniqueId":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }